import { type DateFormatPresetId, formatDateWithPreset } from '@helpers/dates';

/**
 * Format a date as a string using the specified format preset.
 * If no preset is provided, uses the 'medium' format as default.
 *
 * @param value - The date to format
 * @param presetId - Optional format preset ID. If not provided, uses default 'medium' format
 * @returns Formatted date string
 *
 * @example
 * // Use default format
 * getDateAsString(new Date())
 *
 * @example
 * // Use specific format
 * getDateAsString(new Date(), 'short')
 */
const getDateAsString = (value: Date, presetId?: DateFormatPresetId | null): string => {
  return formatDateWithPreset(value, presetId);
};

export { getDateAsString };
